import { type ProfessionalReferenceStatus } from "./types";

export const DEFAULT_PAGE_TITLE = "Professional References";

export const PROFESSIONAL_REFERENCE_STATUS = {
  REQUESTED: "requested",
  VERIFIED: "verified",
  DECLINED: "declined",
  COMPLETED: "completed",
} as const;

// Show approved references on top then follow natural order for the rest
export const REFERENCE_STATUS_SORT_ORDER: Record<ProfessionalReferenceStatus, number> = {
  [PROFESSIONAL_REFERENCE_STATUS.VERIFIED]: 1,
  [PROFESSIONAL_REFERENCE_STATUS.COMPLETED]: 1,
  [PROFESSIONAL_REFERENCE_STATUS.REQUESTED]: 2,
  [PROFESSIONAL_REFERENCE_STATUS.DECLINED]: 2,
} as const;

/**
 * Status display configurations
 */
export const STATUS_CONFIG = {
  [PROFESSIONAL_REFERENCE_STATUS.REQUESTED]: {
    label: "In review",
    intent: "neutral" as const,
  },
  [PROFESSIONAL_REFERENCE_STATUS.VERIFIED]: {
    label: "Approved",
    intent: "success" as const,
  },
  [PROFESSIONAL_REFERENCE_STATUS.COMPLETED]: {
    label: "Completed",
    intent: "success" as const,
  },
  [PROFESSIONAL_REFERENCE_STATUS.DECLINED]: {
    label: "Rejected",
    intent: "error" as const,
  },
} as const;

/**
 * Form field names
 */
export const FORM_FIELDS = {
  EMPLOYER_NAME: "employerName",
  WORKER_TITLE: "workerTitle",
  REFERENCE_FIRST_NAME: "referenceFirstName",
  REFERENCE_LAST_NAME: "referenceLastName",
  REFERENCE_PHONE: "referencePhone",
  REFERENCE_EMAIL: "referenceEmail",
  EMPLOYMENT_START_DATE: "employmentStartDate",
  EMPLOYMENT_END_DATE: "employmentEndDate",
} as const;

/**
 * Validation messages
 */
export const VALIDATION_MESSAGES = {
  REQUIRED: "Required field",
  EMPLOYER_MIN_LENGTH:
    "Employer name must contain more than two characters. Please enter a valid name.",
  EMPLOYER_NO_CLIPBOARD:
    "We do not accept references from Clipboard. Please add a reference from a previous or current employer.",
  NAME_MIN_LENGTH: "Please enter a valid name.",
  NAME_INVALID_CHARS:
    "Name cannot contain numbers or special characters. Please enter a valid name.",
  START_DATE_FUTURE: "Start date cannot be in the future.",
  END_DATE_BEFORE_START: "End date cannot be before start date.",
  END_DATE_FUTURE: "End date cannot be in the future.",
  INVALID_DATE: "Invalid date.",
  INVALID_PHONE: "Please provide a valid phone number.",
  INVALID_EMAIL: "Please provide a valid email address.",
} as const;

export const PROFESSIONAL_SHARE_FLOW = {
  CREATE: "create",
  REMIND: "remind",
} as const;

export const KNOWN_CREATE_REFERENCE_USER_ERROR_MESSAGES: Record<string, string | undefined> = {
  "Duplicate reference added":
    "Reference with same details already exists, please add a different reference.",
  "References completed already!":
    "Required number of references are completed, no more references can be added.",
  "Invalid Phone Number": "Please provide a valid US phone number.",
  "Invalid Email Address": "Please provide a valid email address.",
};
